import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

export const getDocumentText = (doc) => {
  const { type, accrualSubType, sum, subtype, startDateTime, endDateTime, actID1C } = doc;

  if (type === 'CashWarrant') {
    const subTypeText = {
      income: 'Приходный',
      cost: 'Расходный',
    };

    return `${subTypeText[subtype] || ''} кассовый ордер на ${sum} грн`;
  }

  if (type === 'Accrual') {
    return `${subtype} на сумму ${sum} грн за ${accrualSubType}`;
  }

  if (type === 'TransferAct') {
    if (subtype === 'reservation') {
      return <Link className="nounderline" to={'/reservation/' + actID1C}>Резервация до {moment(startDateTime * 1000).format('DD.MM.YYYY HH:mm')}</Link>;
    }

    if (subtype === 'give') {
      return <Link className="nounderline" to={'/rent/' + actID1C}>Передача оборудования в аренду от {moment(endDateTime * 1000).format('DD.MM.YYYY')}</Link>;
    }

    if (subtype === 'receive') {
      return <Link className="nounderline" to={'/rent/' + actID1C}>Возврат оборудования от {moment(endDateTime * 1000).format('DD.MM.YYYY')}</Link>;
    }
  }

  return '';
};
